import type { Entry, TagLink } from 'contentful';

import type { ContentfulContentTypeEntry } from '../contentful-content-type-entries-machine.types';

// ─── Entries ─────────────────────────────────────────────────────────────────

/**
 * Extracts required data from content type entry.
 */
export function extractContentTypeEntryData<ContentTypeFields>(
  entry: Entry<ContentTypeFields>,
): ContentfulContentTypeEntry<ContentTypeFields> {
  return {
    fields: entry?.fields,
    tags: generateTagsIDsSet(entry.metadata.tags),
  };
}

// ─── Tags ────────────────────────────────────────────────────────────────────

function generateTagsIDsSet(tags: readonly TagLink[]): ReadonlySet<string> {
  return new Set(tags.map((tag) => tag.sys.id));
}
